export const Logo = require('./logo.png') as string;
export const BgLogin = require('./bg-login.jpg') as string;
export const Add = require('./add.png') as string;
export const Report = require('./report.png') as string;
export const Export = require('./export.png') as string;
